import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function AuditReports() {
  const reportTypes = [
    { label: "Audit Trails", api: "/pms/reports/audit-trails" },
    { label: "IP Report", api: "/pms/reports/ip-report" },
    { label: "Void Charge", api: "/pms/reports/void-charge" },
    { label: "Void Payment", api: "/pms/reports/void-payment" },
    { label: "Void Transaction", api: "/pms/reports/void-transaction" },
  ];

  return (
    <ReportPageTemplate
      title="Audit Reports"
      desc="System logs, void actions, charge tracking"
      reportTypes={reportTypes}
    />
  );
}
